<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="GOST_headers"
        :items="GOST_items"
        class="elevation-1"
        :loading="GOSTLoading"
        loading-text="Загружаю данные"
        item-key="GOST_ID"
        show-select
        single-select
        :search="GOSTSearch"
        :footer-props="{
          itemsPerPageText: 'На страницу',
          itemsPerPageAllText: 'Все',
          pageText: 'из'
        }"
        dense
        :value="value"
        @input="setValue"
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>Привязки ГОСТ к типам топлива</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="GOSTSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'

export default {
  name: 'refGOST2FTTable',
  props: ['value'],
  data () {
    return {
      GOST_headers: [
        {
          text: 'Наименование',
          value: 'GOST_NAME'
        },
        {
          text: 'Код',
          value: 'GOST_CODE'
        },
        {
          text: 'Группа',
          value: 'FT.FT_NAME'
        }
      ],
      GOSTLoading: false,
      GOSTSearch: '',
      GOST_items: []
    }
  },

  computed: {},
  watch: {
    value (val) {
      if (!val || !val.length || !val[0].GOST_ID) return
      const curr = this.GOST_items.findIndex(itm => itm.GOST_ID === val[0].GOST_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.GOST_items.splice(curr, 1)
          this.setValue([])
          return
        }
        this.GOST_items.splice(curr, 1, val[0])
      } else {
        this.GOST_items.push(val[0])
      }
    }
  },
  mounted: function () {
    if (this.GOST_items.length === 0) {
      this.getGOSTList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getGOSTList () {
      const self = this
      this.cmpLoading = true
      axios({
        url: '/api/org/references/getGOST2FTList.php',
        method: 'POST'
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.GOST_items.splice(0, self.GOST_items.length, ...resp.data.data)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${err}` })
        })
        .finally(
          this.cmpLoading = false
        )
    }
  }
}

</script>
